﻿/**
 * search-presenter.js
 * Delegates chat search to the service and returns normalised payloads.
 */
export class SearchPresenter {
  constructor({ searchService } = {}) {
    if (!searchService || typeof searchService.searchChats !== 'function') {
      throw new Error('SearchPresenter requires a searchService with searchChats');
    }
    this.searchService = searchService;
  }

  async search(query) {
    const payload = await this.searchService.searchChats(query);
    const safePayload = payload && typeof payload === 'object' ? payload : {};
    const results = Array.isArray(safePayload.results) ? safePayload.results : [];
    const source = safePayload.source || 'service';

    return {
      ...safePayload,
      results,
      source,
    };
  }
}

if (typeof window !== 'undefined') {
  window.AgileProPresenters = window.AgileProPresenters || {};
  window.AgileProPresenters.SearchPresenter = SearchPresenter;
}

